import { useState } from 'react'
import { FormContent } from '@bm-js/atlascloud-ui'
import {
  DynamicContentType,
  FormData,
  pWaitFor,
} from '@bm-js/atlascloud-shared'

type Props = {
  content: DynamicContentType<FormData>
}

const FormWrapper = ({ content }: Props) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = async (data: any) => {
    setLoading(true)
    const { fields, contactEmail } = data

    await pWaitFor(2000)

    if (!contactEmail) {
      alert("Du måste fylla 'Kontaktmail' för att formuläret ska fungera")
      return setLoading(false)
    }

    const fieldValues = Object.keys(fields).map((key) => ({
      name: key,
      value: fields[key],
    }))

    alert(`I hemsideredigeraren skickas inga faktiska e-postmeddelanden.
På er hemsida skulle ett mail skickas till ${contactEmail} med följande innehåll:

${fieldValues.map((field) => `${field.name}: ${field.value}`).join('\n')}
`)

    setSuccess(true)
    setLoading(false)
  }

  return (
    <FormContent
      content={content}
      handleSubmit={handleSubmit}
      error={false}
      success={success}
      loading={loading}
    />
  )
}

export default FormWrapper
